// HIGHLIGHT STEPS ON SCROLL
document.addEventListener('DOMContentLoaded', function () {

    // Function to handle the scroll animation
    function handleStepAnimations() {
        const widgets = document.querySelectorAll('.db-widget.steps');

        widgets.forEach(widget => {
            // Pak alle nummers in de widget
            const steps = widget.querySelectorAll('.numbered-list h3 span');

            steps.forEach(step => {
                const rect = step.getBoundingClientRect();
                const windowHeight = window.innerHeight;

                // Trigger zodra de "bol" ongeveer halverwege in beeld is
                const triggerPoint = windowHeight * 0.6;

                if (rect.top < triggerPoint && rect.bottom > 0) {
                    step.classList.add('animate');
                } else {
                    step.classList.remove('animate');
                }
            });
        });
    }

    // Run bij scroll en resize
    window.addEventListener('scroll', handleStepAnimations);
    window.addEventListener('resize', handleStepAnimations);

    // Direct even runnen bij laden
    handleStepAnimations();
});